import Generator from '../../../../Generator'
import Types from '../../../../../actions/Types'

export default Generator.node({
  baseType: Types.MAINTENANCES,
  nodeType: Generator.NODETYPE.GET,
  suffixType: 'BASIC'
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/maintenances/get/basic.js